// Animation handler for FAQ accordion
// Applies selected animation to all details inside collapsible-content sections

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.collapsible-content[data-faq-animation]').forEach((section) => {
    const animation = section.dataset.faqAnimation;
    section.querySelectorAll('details').forEach((detail) => {
      const summary = detail.querySelector('summary');
      const content = detail.querySelector('.accordion__content');
      content.style.overflow = 'hidden';
      summary.addEventListener('click', (event) => {
        event.preventDefault();
        detail.hasAttribute('open')
          ? closeAccordion(detail, content, animation)
          : openAccordion(detail, content, animation);
      });
    });
  });
});

function openAccordion(detail, content, animation) {
  detail.setAttribute('open', true);
  const height = content.scrollHeight;
  if (animation === 'slide') {
    content.style.height = '0px';
  }
  const player = content.animate(getKeyframes(height, animation, false), {
    duration: 300,
    easing: 'ease',
  });
  if (animation === 'slide') {
    player.onfinish = () => {
      content.style.height = 'auto';
    };
  }
}

function closeAccordion(detail, content, animation) {
  const height = content.scrollHeight;
  if (animation === 'slide') {
    content.style.height = height + 'px';
  }
  const player = content.animate(getKeyframes(height, animation, true), {
    duration: 300,
    easing: 'ease',
  });
  player.onfinish = () => {
    detail.removeAttribute('open');
    if (animation === 'slide') {
      content.style.height = 'auto';
    }
  };
}

function getKeyframes(height, animation, isClosing) {
  switch (animation) {
    case 'fade':
      return isClosing ? [{ opacity: 1 }, { opacity: 0 }] : [{ opacity: 0 }, { opacity: 1 }];
    case 'zoom':
      return isClosing
        ? [
            { opacity: 1, transform: 'scale(1)' },
            { opacity: 0, transform: 'scale(0.95)' },
          ]
        : [
            { opacity: 0, transform: 'scale(0.95)' },
            { opacity: 1, transform: 'scale(1)' },
          ];
    case 'slide':
    default:
      return isClosing
        ? [{ height: height + 'px' }, { height: '0px' }]
        : [{ height: '0px' }, { height: height + 'px' }];
  }
}

